"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.backend = void 0;
const language_1 = require("./language");
var LocizeLang;
(function (LocizeLang) {
    LocizeLang["SE"] = "sv-SE";
    LocizeLang["EN"] = "en-GB";
})(LocizeLang || (LocizeLang = {}));
var enLangBlob;
var svLangBlob;
const getMissingData = (namespace, language) => __awaiter(void 0, void 0, void 0, function* () {
    const data = yield (0, language_1.getLocizeLanguage)(namespace, language);
    const newData = {
        [namespace]: data,
    };
    if (language === LocizeLang.EN) {
        enLangBlob = Object.assign(Object.assign({}, enLangBlob), newData);
    }
    else {
        svLangBlob = Object.assign(Object.assign({}, svLangBlob), newData);
    }
    return data;
});
exports.backend = {
    type: "backend",
    init: function () {
        return __awaiter(this, void 0, void 0, function* () {
            if (!enLangBlob) {
                enLangBlob = yield (0, language_1.getAllLocizeNamespaces)(LocizeLang.EN);
            }
            if (!svLangBlob) {
                svLangBlob = yield (0, language_1.getAllLocizeNamespaces)(LocizeLang.SE);
            }
        });
    },
    read: function (language, namespace, callback) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                var data = language === LocizeLang.EN
                    ? enLangBlob[namespace]
                    : svLangBlob[namespace];
                if (!data) {
                    data = yield getMissingData(namespace, language);
                }
                callback(null, data);
            }
            catch (e) {
                const data = yield getMissingData(namespace, language);
                callback(null, data);
            }
        });
    },
};
//# sourceMappingURL=i18nextBackend.js.map